<template>
  <div class="llfx-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            <el-form :inline="true" size="small" :model="searchForm" style="float: right;">
              <el-form-item label="选择日期">
                <el-date-picker
                  v-model="searchForm.time"
                  format="yyyy年MM月dd日"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  type="daterange">
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button :loading="llLoading" icon="el-icon-s-data" type="primary" @click="getData">统计</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="card-content">
            <el-row>
              <el-col :span="24" :loading="llLoading">
                <GraphicsChart id="llChart" :option="llOption"/>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import GraphicsChart from '../../../components/Charts/GraphicsChart'
import { getLoginCount } from '@/api/user'

export default {
  name: 'llfx',
  components: {
    GraphicsChart
  },
  data() {
    return {
      tableData: [],
      loading: false,
      llLoading: false,
      searchForm: {
        time: []
      },
      llOption: {
        title: false,
        credits: {
          enabled: false
        }
      }
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      let startTime = ''
      let endTime = ''
      if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
        startTime = this.searchForm.time[0]
        endTime = this.searchForm.time[1]
      }
      const data = {
        startTime: startTime,
        endTime: endTime
      }
      getLoginCount(data).then(response => {
        const chart = {
          chart: {
            type: 'spline',
            inverted: false
          },
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          credits: {
            enabled: false
          },
          title: {
            text: '登录时间分析'
          },
          yAxis: {
            title: {
              text: '登录次数'
            }
          },
          legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle'
          },
          xAxis: {
            categories: response.data.dateHour,
            crosshair: true,
            title: '登录时间'
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: '{point.y}'
              }
            }
          },
          series: response.data.lineData
        }
        this.llOption = chart
        this.llLoading = false
      }).catch(() => {
        this.llLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tcf-bb-table{
  width: 100%;
  background-color: #fff;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 13px;
  text-align: center;
  thead{
    color: #909399;
    font-weight: 500;
    tr{
      th{
        border: 1px solid #EBEEF5;
        background: #f6f8fa;
        color: #303133;
        padding: 10px;
      }
    }
  }
  tbody{
    tr{
      th{
        border: 1px solid #EBEEF5;
        background: #f6f8fa;
        color: #303133;
        padding: 10px;
      }
      td{
        border: 1px solid #EBEEF5;
        color: #303133;
        padding: 12px 0;
      }
      &:hover{
        background: #f3f6f9;
      }
    }
  }
}
</style>
